import { convertToBoolOrUndefined } from 'utils/helpers';

export const createCustomTunnelStep = ({
    ppStepOrder,
    pmStepOrder,
    ppTunnelPhaseId,
    pmTunnelPhaseId,
    newStep,
}) => ({
    ppStepOrder: ppStepOrder + 1,
    ppTunnelPhaseId,
    pmStepOrder: pmStepOrder + 1,
    pmTunnelPhaseId,
    title: newStep.title,
    description: newStep.subtitle,
    step: 'api/steps/49',
    mandatory: true, // custom steps are all mandatory for cloning tunnels
    questions: newStep.questions.map((q, idx) => ({
        ...q,
        order: idx + 1,
        mandatory: convertToBoolOrUndefined(q.mandatory),
        answers: q.answers.map((a, index) => ({ ...a, order: index + 1 })),
    })),
});

export const createQuestion = ({ form, ppTunnelStepId, pmTunnelStepId, questionIndex }) => ({
    ...form,
    answers: form.answers.map((a, idx) => ({ ...a, order: idx + 1 })),
    ppId: ppTunnelStepId,
    pmId: pmTunnelStepId,
    order: questionIndex + 1,
    mandatory: convertToBoolOrUndefined(form.mandatory),
});

export const updateQuestion = ({ form, ppQuestionId, pmQuestionId }) => ({
    ...form,
    order: undefined, // do not change order here - overrwrite
    ppQuestionId,
    pmQuestionId,
    mandatory: convertToBoolOrUndefined(form.mandatory),
});

export const createAnswer = ({ ppQuestionId, pmQuestionId, form, index }) => ({
    ppQuestionId,
    pmQuestionId,
    ...form,
    score: +form.score,
    order: index + 1,
});

export const updateAnswer = ({ ppId, pmId, form }) => ({
    ppId,
    pmId,
    ...form,
    score: +form.score,
    order: undefined, // do not change order here
});

export const createAction = ({
    newAction,
    ppTunnelId,
    pmTunnelId,
    ppTunnelQuestions,
    pmTunnelQuestions,
}) => {
    let questionIndexes = newAction.questions.map(q =>
        ppTunnelQuestions.findIndex(ppQ => ppQ.id === q.id)
    );
    const { conditions, questions, ...actionForm } = newAction;
    return {
        ...actionForm,
        conditions: conditions.map(c => ({ ...c, limitValue: +c.limitValue })),
        ppTunnelId,
        pmTunnelId,
        ppQuestions: newAction.questions.map(q => `api/questions/${q.id}`), // selected questions
        pmQuestions: pmTunnelQuestions
            .filter((_q, idx) => questionIndexes.includes(idx))
            .map(q => `api/questions/${q.id}`), // match PM tunnel questions with PP tunnel questions by index
    };
};

export const updateAction = ({ action, ppId, pmId, ppQuestions, pmQuestions }) => {
    let questionIndexes = action.questions.map(q => ppQuestions.findIndex(ppQ => ppQ.id === q.id));
    const { conditions, questions, ...actionForm } = action;
    return {
        action: actionForm,
        ppId,
        pmId,
        ppQuestions: action.questions.map(q => `api/questions/${q.id}`), // selected questions
        pmQuestions: pmQuestions
            .filter((_q, idx) => questionIndexes.includes(idx))
            .map(q => `api/questions/${q.id}`), // match PM tunnel questions with PP tunnel questions by index
    };
};
